var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcVerifiedAndDisputed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 12,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1C5.95 1 1 5.95 1 12C1 18.05 5.95 23 12 23C18.05 23 23 18.05 23 12C23 5.95 18.05 1 12 1ZM11.1357 5.71429H12.8643V14.3571H11.1357V5.71429ZM12 19.0714C11.3714 19.0714 10.8214 18.5214 10.8214 17.8929C10.8214 17.2643 11.3714 16.7143 12 16.7143C12.6286 16.7143 13.1786 17.2643 13.1786 17.8929C13.1786 18.5214 12.6286 19.0714 12 19.0714Z",
    fill: "#50AFF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVerifiedAndDisputed);
export default __webpack_public_path__ + "static/media/ic-verified-and-disputed.7802ef40f8427cfff24c926999493b18.svg";
export { ForwardRef as ReactComponent };